var config = require('../config').config;
var raygun = require('../raygun');

var script = function(src) {
  var s = document.createElement('script')
  s.src = src
  s.async
  return document.head.appendChild(s)
}

window.onload = function () {

  /**
 * The Sign-In client object.
 */
  var auth2;

  /**
   * Initializes the Sign-In client.
   */
  
  gapi.load('auth2', function(){
      /**
       * Retrieve the singleton for the GoogleAuth library and set up the
       * client.
       */
      auth2 = gapi.auth2.init({
        client_id: config.googleClientID,
        scope: 'profile email',
      });
    
      gapi.signin2.render('google-signin2', {
        'longtitle': true,
        'theme': 'light',
        'height': 40,
      });

      // Attach the click handler to the sign-in button
      auth2.attachClickHandler('google-signin2', {}, onSignIn, onFailure);
  });
      
}

/**
   * Handle sign-in success.
   */

function onSignIn(googleUser) {
  if (googleUser.isSignedIn()) {
    checkifMember(JSON.stringify(googleUser))
  }
}

/**
   * Handle sign-in failures.
   */
var onFailure = function(error) {
  console.log(error);
};

function checkifMember(googleUser) {
  var formData = new FormData();
  formData.append('idToken', googleUser);
  
  fetch('/' + config.translationPath + '/registration/googlemember', {
        method: 'POST',
        body: formData
      })
      .then(function (res) {
        return res.json();
      })
      .then(
        function (res) {
          if (res.isValid) {
            if (res.isMember) {
              window.location.replace(res.redirectURL);
            } else {
              registerGoogleMember(googleUser)
            }
          }
        }
      )
    .catch(function (error) {
      raygun.sendError(error, 'googleSignIn');
    });
}

function registerGoogleMember (id_token) {

  var formData = new FormData();
  formData.append('idToken', id_token);
  
  fetch('/' + config.translationPath + '/registration/googleRegisterMember/', {
    method: 'POST',
    body: formData
  })
  .then(function (res) {
    return res.json();
  })
  .then(
    function (res) {
      window.location.replace(res.redirectURL);
    }
  )
  .catch(function (error) {
    raygun.sendError(error, 'registerGoogleMember'); 
  });
}

script("https://apis.google.com/js/platform.js")